import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteGrievanceNatureModel} from '../Model'
import {GrievanceNatureModel} from '../Model/GrievanceNatureModel'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const GRIEVANCE_NATURE = `${API_URL}/grievance/nature`

export const service = {
  getGrievanceNature: (params: ParamsModel) => {
    return axios.get(GRIEVANCE_NATURE, {params})
  },
  getAllGrievanceNature: () => {
    return axios.get(`${GRIEVANCE_NATURE}/list`)
  },

  addGrievanceNature: (data: any) => {
    return axios.post(GRIEVANCE_NATURE, data)
  },

  updateGrievanceNature: (body: GrievanceNatureModel, id: string) => {
    return axios.put(`${GRIEVANCE_NATURE}/${id}`, body)
  },

  deleteGrievanceNature: (data: DeleteGrievanceNatureModel) => {
    return axios.delete(`${GRIEVANCE_NATURE}/bulk-delete`, {data})
  },

  enableGrievanceNature: (data: Array<string>) => {
    const selectedGrievanceNature = {
      nature: data,
    }
    return axios.put(`${GRIEVANCE_NATURE}/bulk-active`, selectedGrievanceNature)
  },

  disableGrievanceNature: (data: Array<string>) => {
    const selectedGrievanceNature = {
      nature: data,
    }
    return axios.put(`${GRIEVANCE_NATURE}/bulk-inactive`, selectedGrievanceNature)
  },

  singleEnableGrievanceNature: (data: Array<string>) => {
    const selectedGrievanceNature = {
      nature: [data],
    }
    return axios.put(`${GRIEVANCE_NATURE}/bulk-active`, selectedGrievanceNature)
  },

  singleDisableGrievanceNature: (data: Array<string>) => {
    const selectedGrievanceNature = {
      nature: [data],
    }
    return axios.put(`${GRIEVANCE_NATURE}/bulk-inactive`, selectedGrievanceNature)
  },
}

